// ======================================================================
// File Name       : ContentNotificationConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================
import React from 'react';
import { Form, FormControl, Col, Button, Table, Modal } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import { Link } from 'react-router-dom';
import TableHead from '../TableHead';
import * as Path from '../../constants/PathConstants';
import { MODE, VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../../components/FormControlValidate';
import * as MessageTemplate from '../../constants/MessageTemplate';
import ContentDetail from './ContentLinkDetail';

const ContentLinkConfirmDialog = ({
  contentLink,
  handleOkClick,
  handleCancelClick,
  showModal,
}) => {
  const data = {
    contentLink: contentLink
  }
  const style = {
    background: 'none',
    width: 'auto',
    marginLeft: 0,
    left: 0,
  };
  return (
    <Modal className="modal-container" show={showModal} style={style}>
      <Modal.Header onHide={handleCancelClick} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ContentDetail
            {...data}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button variant="default" className=" margin-right-10 btn btn-default btn-96" onClick={handleCancelClick}>
          キャンセル
        </Button>
        <Button className=" margin-left-10 btn-96" variant="primary" onClick={handleOkClick}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ContentLinkConfirmDialog;
